import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import {
    createProduct,
    deleteProduct,
    getProductById,
    getProductList,
    updateProduct,
} from '../../services/ProductService'

interface GetProductListParams {
    pageNumber: number
    pageSize: number
    filterkey: any
}

interface ProductState {
    ProductList: any
    product: any
}

const initialState: ProductState = {
    ProductList: null,
    product: null,
}

// Fetch product list
export const getProductListApi = createAsyncThunk(
    'product/getProductList',
    async ({ pageNumber, pageSize, filterkey }: GetProductListParams, { rejectWithValue }) => {
        try {
            const result = await getProductList(pageNumber, pageSize, filterkey)
            return result.data
        } catch (error) {
            return rejectWithValue({ error })
        }
    }
)

// Fetch product by ID
export const getProductByIdApi = createAsyncThunk(
    'product/getProductById',
    async (id: any, { rejectWithValue }) => {
        try {
            const result = await getProductById(id)
            return result.data
        } catch (error) {
            return rejectWithValue({ error })
        }
    }
)

// Create a new product
export const createProductApi = createAsyncThunk(
    'product/createProduct',
    async (payload: any, { rejectWithValue }) => {
        try {
            const result = await createProduct(payload)
            return result.data
        } catch (error) {
            return rejectWithValue({ error })
        }
    }
)

// Update product
export const updateProductApi = createAsyncThunk(
    'product/updateProduct',
    async ({ id, payload }: { id: any; payload: any }, { rejectWithValue }) => {
        try {
            const result = await updateProduct(id, payload)
            return result.data
        } catch (error) {
            return rejectWithValue({ error })
        }
    }
)

// Delete product
export const deleteProductApi = createAsyncThunk(
    'product/deleteProduct',
    async (id: any, { rejectWithValue }) => {
        try {
            const result = await deleteProduct(id)
            return result.data
        } catch (error) {
            return rejectWithValue({ error })
        }
    }
)

const ProductSlice = createSlice({
    name: 'product',
    initialState,
    reducers: {},

    extraReducers: (builder) => {
        builder
            .addCase(getProductListApi.fulfilled, (state, action) => {
                state.ProductList = action.payload
            })
            .addCase(getProductByIdApi.fulfilled, (state, action) => {
                state.product = action.payload
            })
            .addCase(createProductApi.fulfilled, (state, action) => {
                state.product = action.payload
            })
            .addCase(updateProductApi.fulfilled, (state, action) => {
                state.product = action.payload
            })
            .addCase(deleteProductApi.fulfilled, (state, action) => {
                state.product = null
            })
    },
})

export default ProductSlice
